export default (element) => {
  const scrollToId = (e) => {
    const block = document.getElementById(
      e.currentTarget.dataset.designerGroup,
    );
    const designerNav = document.querySelector('[data-designer-nav]');
    const designerNavHeight = designerNav
      ? designerNav.getBoundingClientRect().height
      : 0;
    const offset = block.offsetTop - designerNavHeight + 10;
    if (block) {
      window.scrollTo({
        top: offset,
        behavior: 'smooth',
      });
    }
  };

  const init = () => {
    const wordButtons = element.querySelectorAll('[data-designer-group]');
    wordButtons.forEach((btn) =>
      btn.addEventListener('click', (e) => scrollToId(e)),
    );
  };

  const isElementInViewport = (el, headerHeight, filterBarHeight) => {
    const rect = el.getBoundingClientRect();
    const effectiveTop = rect.top - headerHeight - filterBarHeight;
    return effectiveTop >= 0 && effectiveTop <= window.innerHeight / 2;
  };

  const setActiveFilter = () => {
    const filterBarEl = element.querySelector('.filter-bar');
    const headerEl = document.querySelector('[data-section="header"]');

    if (!filterBarEl || !headerEl) return;

    const headerHeight = headerEl.getBoundingClientRect().height;
    const filterBarHeight = filterBarEl.getBoundingClientRect().height;

    const wordSections = element.querySelectorAll('.designer-group');

    const sortedSections = Array.from(wordSections).sort((a, b) => {
      const rectA = a.getBoundingClientRect();
      const rectB = b.getBoundingClientRect();
      return Math.abs(rectA.top) - Math.abs(rectB.top);
    });

    const activeSection = sortedSections.find((section) =>
      isElementInViewport(section, headerHeight, filterBarHeight),
    );

    if (activeSection?.id) {
      filterBarEl.querySelectorAll('[data-designer-group]').forEach((btn) => {
        btn.classList.remove('underline');
      });

      const activeFilterBtn = element.querySelector(
        `[data-designer-group=${activeSection.id}]`,
      );
      activeFilterBtn.classList.add('underline');
    }
  };

  init();
  setActiveFilter();

  window.addEventListener('scroll', () => setActiveFilter());
};
